import { combineReducers } from "redux";
import LoginReducer from "../../../../Screens/Login/Store/reducer";
import LanguageDropdownReducer from "../../../../localization/Store/reducer";

export default combineReducers({
    login: LoginReducer,
    languageDropdown: LanguageDropdownReducer
})